import { render, staticRenderFns } from "./FooterBtn.vue?vue&type=template&id=14da59f1&scoped=true"
import script from "./FooterBtn.vue?vue&type=script&lang=js"
export * from "./FooterBtn.vue?vue&type=script&lang=js"
import style0 from "./FooterBtn.vue?vue&type=style&index=0&id=14da59f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da59f1",
  null
  
)

export default component.exports